import './Keypad.scss';
import backspace from '../../assets/icons/backspace.svg';
import { gameStore, useTranslation } from '../../platform/stores';
import { keypadStore } from '../../platform/stores/keypadStore';
import { observer } from 'mobx-react';
import { abbrNum } from '../../platform/utils';

export const Keypad = observer(() => {
  const t = useTranslation();
  const { minBetAmount, maxBetAmount, quickBets } = gameStore;
  const { text, setText, opened, setOpened, onSave } = keypadStore;

  const validateAndSetText = (text: string) => {
    if (text.length < 12) {
      setText(text);
    }
  }

  const addNumber = (number: number) => {
    validateAndSetText(text + number);
  }

  const addDot = () => {
    if (text && !text.includes('.')) {
      validateAndSetText(text + '.');
    }
  }

  const addZero = () => {
    if (text !== '0') {
      validateAndSetText(text + '0');
    }
  }

  const removeLastNumber = () => {
    validateAndSetText(text.slice(0, -1));
  }

  const close = () => {
    setOpened(false);
  }

  const save = () => {
    setOpened(false);
    try {
      if (onSave) {
        onSave(+text);
      }
    }
    catch (e) {

    }
  }

  const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      {
        opened
          ?
          <div className="keypad-component">
            <div className="keypad-background" onClick={() => close()}></div>
            <div className="keypad">
              <div className="title">{t('KEYPAD_BET_AMOUNT')}</div>
              <div className="row first">
                <div className="button flex-center" onClick={() => validateAndSetText(minBetAmount.toString())}>{t('KEYPAD_MIN')}</div>
                <div className="input flex-center">{text}</div>
                <div className="button flex-center" onClick={() => validateAndSetText(maxBetAmount.toString())}>{t('KEYPAD_MAX')}</div>
              </div>
              <div className="row second">
                {
                  quickBets.map((item) =>
                    <div key={item} className="button flex-center" onClick={() => setText(item.toString())}>{abbrNum(item)}</div>
                  )
                }
              </div>
              <div className="row third">
                {
                  numbers.map((number) =>
                    <div key={number} className="button flex-center" onClick={() => addNumber(number)}>{number}</div>
                  )
                }
              </div>
              <div className="row fourth">
                <div className="button flex-center" onClick={() => addZero()}>0</div>
                <div className="button flex-center" onClick={() => addDot()}>.</div>
                <div className="button flex-center" onClick={() => removeLastNumber()}>
                  <img src={backspace} alt="Backspace" className="backspace-icon"/>
                </div>
                <div className="button flex-center green" onClick={() => save()}>{t('KEYPAD_OK')}</div>
              </div>
            </div>
          </div>
          :
          <></>
      }
    </>
  );
});
